import { Badge, Flex, Grid, SelectField } from "@aws-amplify/ui-react";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";

import { listActions } from "graphql/queries";

const DeviceActionForm = ({
  initialValues,
  onChangeActions,
  refreshInitialValues,
}) => {
  const [deviceActionList, setDeviceActionList] = useState([]);
  const [actions, setActions] = useState([]);

  const onDelete = (index) => {
    setDeviceActionList((prevSt) => {
      const listUpdated = [...prevSt];
      listUpdated.splice(index, 1);
      if (onChangeActions) onChangeActions(listUpdated);
      return listUpdated;
    });
  };

  const onSelect = (e) => {
    const { value } = e.target;

    setDeviceActionList((prevSt) => {
      const listUpdated = [
        ...prevSt,
        {
          actionID: value,
        },
      ];
      if (onChangeActions) onChangeActions(listUpdated);
      return listUpdated;
    });
  };

  async function fetchActions() {
    try {
      const actionsData = await API.graphql(graphqlOperation(listActions));
      const actionsItems = actionsData.data.listActions.items;
      setActions(actionsItems);
    } catch (err) {
      toast.error(strings.responses.errorFetchActions);
    }
  }

  useEffect(() => {
    setDeviceActionList(initialValues ?? []);
  }, [initialValues, refreshInitialValues]);

  useEffect(() => {
    fetchActions();
  }, []);

  return (
    <Grid rowGap="15px">
      <Grid templateColumns={{ base: "1fr" }} rowGap="15px" columnGap="15px">
        <SelectField
          name="action"
          label={strings.fields.addAction.label}
          onChange={onSelect}
        >
          <option value="">{strings.selectOption}</option>
          {actions
            ?.filter(
              (action) =>
                !deviceActionList?.some(
                  (devAct) => devAct.actionID === action.id
                )
            )
            .map((action) => (
              <option key={action.id} value={action.id}>
                {action.name}
              </option>
            ))}
        </SelectField>
      </Grid>
      <Flex rowGap="10px" columnGap="10px" wrap="wrap">
        {deviceActionList?.map((devAct, index) => (
          <Badge key={index}>
            {actions?.find((action) => action.id === devAct.actionID)?.name}
            &nbsp;
            <CloseIcon
              style={{ cursor: "pointer" }}
              fontSize="inherit"
              onClick={() => onDelete(index)}
            />
          </Badge>
        ))}
      </Flex>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    selectOption: "Seleccione una opción",
    fields: {
      addAction: {
        label: "Agregar Acción",
      },
    },
    responses: {
      errorFetchActions: "Error al consultar acciones",
    },
  },
});

export default DeviceActionForm;
